import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      tableData: [],
      statusList: [{
        lable: '正常',
        value: 1
      }, {
        lable: '禁用',
        value: 2
      }, {
        lable: '审核中',
        value: 3
      }]
    };
  },
  mounted: function mounted() {},
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                _this.getList();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    rewriteClearData: function rewriteClearData() {
      this.valuearray = [];
      this.clearData();
    },
    getList: function getList() {
      var _this2 = this;

      this.$api.authAppList().then(function (resq) {
        if (resq.status == 200) {
          _this2.tableData = resq.data;
        }
      });
    }
  }
};